// Route guard based on feature flags

export default defineNuxtRouteMiddleware((to) => {
  if (to.name === 'iframe') {
    if (!getFeatureActive('IframeTest')) {
      return navigateTo('/404')
    }
  }

  if (to.name === 'system-admin-voices') {
    if (!getFeatureActive('VoiceCall')) {
      return navigateTo('/404')
    }
  }

  if (
    typeof to.name === 'string' &&
    to.name.includes('sequences') &&
    to.name.includes('workspaceId')
  ) {
    if (!getFeatureActive('Sequences')) {
      return navigateTo('/404')
    }
  }
})
